// extracted by mini-css-extract-plugin
export var idIndicator = "we-are-section-module--id-indicator--NxJDN";
export var photoColumn = "we-are-section-module--photo-column--6WYVq";
export var photoWrapper = "we-are-section-module--photo-wrapper--o91Ps";